import {
  FormControl,
  FormHelperText,
  InputLabel,
  TextField
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { useState } from 'react';
import { PatternFormat } from 'react-number-format';

const useStyles: any = makeStyles((theme: any) => ({
  container: {
    width: '100%',
    '& label.Mui-focused': {
      color: `${theme.palette.primary[500]} !important`
    }
  },
  label: {
    color: `${theme.palette.text.primary} !important`,
    background: 'white',
    display: 'block',
    padding: '0 6px'
  },
  error: {
    '& label': {
      color: `${theme.palette.error.main} !important`
    },
    '& label.Mui-focused': {
      color: `${theme.palette.error.main} !important`
    },
    '& p': {
      color: `${theme.palette.error.main} !important`
    },
    '& fieldset': {
      borderColor: `${theme.palette.error.main} !important`
    }
  }
}));

type Props = {
  fullWidth?: boolean;
  name?: string;
  label?: string;
  onChange: (value: string) => void;
  value?: string;
  inputLabelProps?: any;
  hasError?: boolean;
  helperText?: string;
  disabled?: boolean;
};

export const PhoneInput = ({
  name,
  label,
  onChange,
  value,
  inputLabelProps,
  hasError,
  helperText,
  disabled
}: Props) => {
  const classes = useStyles();
  const [focused, setFocused] = useState(false);
  const onChangeInternal = e => {
    const val = e.target.value;
    onChange(val.replace(/[^0-9.]+/g, '').trim());
  };
  return (
    <FormControl
      focused
      className={
        hasError
          ? clsx(classes.container, classes.error)
          : clsx(classes.container)
      }
      variant="outlined"
    >
      <InputLabel className={classes.label} focused={focused}>
        {label}
      </InputLabel>
      <PatternFormat
        fullWidth
        disabled={disabled}
        customInput={TextField}
        InputLabelProps={inputLabelProps}
        name={name}
        format={
          // here we only enforce the format if the value is at or less than a valid length, otherwise just show the number
          value?.length > 10 ? '#'.repeat(value?.length) : '(###) ###-####'
        }
        value={value}
        onChange={onChangeInternal}
        allowEmptyFormatting
        mask="_"
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      {hasError && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
